import React from 'react'
import {Query} from 'react-apollo'

import GoodPageLayout from './layout'
import Error from '../../base/Error/index'
import Loading from '../../base/Loading/index'
import catalogTypes from '../../catalog/Root/catalog-types'

import goodGql from './good.graphql'

const GoodPageWithData = ({referrerCatalogType, referrerCategoryId, cart, setQuantityInCart, ...props}) => <Query
  query={goodGql}
  variables={{id: props.goodId}}
>
  {({loading, error, data}) => {
    if (loading) return <Loading/>
    if (error) return <Error/>

    const good = data.good
    if (!good) return <Error message={'Ошибка. Товар не найден.'}/>

    let displayCatalogType
    if (referrerCatalogType) {
      displayCatalogType = referrerCatalogType
    } else if (catalogTypes[good.program]) {
      displayCatalogType = catalogTypes[good.program]
    } else {
      return <Error message={'Ошибка. Неизвестный тип товара.'}/>
    }

    let displayCategory
    if (referrerCategoryId) {
      // сначала попробуем найти referrerCategory в списке категорий товара
      displayCategory = good.categories.find(category => category.id === referrerCategoryId)
    } else if (good.categories.length > 0) {
      // если ее там нет, берем просто первую категорию товара
      displayCategory = good.categories[0]
    } else {
      return <Error message={'Ошибка. У товара отсутствует категория'}/>
    }

    return <GoodPageLayout
      {...props}
      displayCatalogType={displayCatalogType}
      referrerCategoryId={referrerCategoryId}
      displayCategory={displayCategory}
      good={data.good}
      quantityInCart={cart[good.id] || 0}
      setQuantityInCart = {(quantity) => setQuantityInCart(good, quantity)}
    />
  }}
</Query>

export default GoodPageWithData
